export default {
"help_title": "المساعدة والدعم",
  "help_subtitle": "قم بإدارة عملك بسهولة من خلال الإرشادات والدعم الكامل.",

  "help_profile_title": "إكمال الملف الشخصي",
  "help_profile_desc": "أكمل بيانات عملك ومتجرك لفتح جميع الميزات.",
  "help_profile_btn": "الذهاب إلى الملف الشخصي",

  "help_dashboard_title": "جولة لوحة التحكم",
  "help_dashboard_desc": "شرح خطوة بخطوة لفهم الطلبات والفواتير والأدوات.",
  "help_dashboard_btn": "ابدأ الجولة",

  "help_tools_title": "الأدوات والميزات",
  "help_tools_desc": "تعلم كيفية استخدام المخزون والعروض والفواتير والتقارير.",
  "help_tools_btn": "استكشاف الأدوات",

  "help_docs_title": "التوثيق",
  "help_docs_desc": "الوصول إلى شرح مفصل مع أمثلة وأفضل الممارسات.",
  "help_docs_btn": "عرض التوثيق",

  "help_support_title": "هل تحتاج إلى مساعدة؟",
  "help_support_desc": "تواصل مع فريق الدعم للحصول على مساعدة سريعة.",
  "help_support_btn": "اتصل بالدعم",
}